<template>
    <div>
        <h1 class="title title--line"><T :title="document.title">Gelieve de achterkant van het document ook te uploaden.</T></h1>
        <a @click="$router.go(-1)" class="button button--ghost">
            <i class="icon-chevron-left button--icon button__icon--left"></i> <T>Klik hier om opnieuw te proberen</T>
        </a>
    </div>
</template>


<script>
    import {mapState} from 'vuex';

    export default {
        name: 'OcrIdSingelSided',
        data: function(){
            return {
                document: null,
            };
        },
        methods: {
            getDocument () {
                let self = this;
                self.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document/' + this.$route.params.document)
                        .then(function(response) {
                            self.document = response.data;
                        })
            }
        },
        created: function() {
            this.getDocument();
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/OcrIdSingelSided.vue